import React, { useState, useRef, useContext } from 'react';
import EmpresaContext from "../../../contexts/Empresa";
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";
import Filters from './Filters'
import Table from './Table';
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Row,
    Col,
} from "reactstrap";
import SimpleHeader from '../../../components/Headers/SimpleHeader'

export default ({ ...props }) => {

    const { empresaSelecionada } = useContext(EmpresaContext)
    const [scripts, setScripts] = useState([])
    const [pageProperties, setPageProperties] = useState({
        total: "0",
        perPage: 10,
        page: 1,
        lastPage: 1,
        loading: false
    })
    const [lastSearch, setLastSearch] = useState({})
    const notificationAlert = useRef();

    function notify(type, msg) {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
                    <span data-notify="message">
                        {msg}
                    </span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 7
        };
        if (notificationAlert && notificationAlert.current) notificationAlert.current.notificationAlert(options);
    }

    function onNewClicked(e) {
        e.preventDefault();
        props.history.push('scripts-venda/new')
    }

    async function updatePageProperties(response) {
        const { total, perPage, page, lastPage } = await response.data
        setPageProperties({
            total,
            perPage,
            page,
            lastPage,
            loading: false,
        })
    }

    async function loadScripts(page = 1,
        limit = 10,
        sortField = "titulo",
        sortOrder = "asc",
        filters = lastSearch) {
        try {
            setPageProperties({
                ...pageProperties,
                loading: true
            })
            const response = await api.get(`common/empresas/${empresaSelecionada?.id}/scripts-venda/`, {
                params: {
                    page,
                    limit,
                    sortField,
                    sortOrder,
                    ...filters
                }
            })
            setScripts(response.data.data)
            await updatePageProperties(response)
        } catch (err) {
            console.log(err.response)
            notify('danger', 'Houve um problema ao carregar scripts de venda.');
        }
    }

    async function handleToggleStatus(script) {
        const isInactive = !!script.deleted_at;
        const msg = isInactive ? "Deseja reativar este script de venda?" : "Deseja inativar este script de venda?";
        if (window.confirm(msg)) {
            try {
                if (isInactive) {
                    await api.put(`common/empresas/${empresaSelecionada?.id}/scripts-venda/${script.id}`, { deleted_at: null })
                } else {
                    await api.delete(`common/empresas/${empresaSelecionada?.id}/scripts-venda/${script.id}`)
                }
                notify('success', `Script de venda ${isInactive ? 'reativado' : 'inativado'} com sucesso.`)
                loadScripts()
            } catch (err) {
                console.log(err)
                notify('danger', 'Houve um problema ao alterar o status do script de venda.')
            }
        }
    }

    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder }) => {
        try {
            await loadScripts(page == 0 ? 1 : page, sizePerPage, sortField, sortOrder)
        } catch (error) {
            notify('danger', 'Houve um problema ao carregar scripts de venda.');
        }
    }

    return (
        <>
            <div className="rna-wrapper">
                <NotificationAlert ref={notificationAlert} />
            </div>
            <SimpleHeader name="Listagem de Scripts de Venda" parentName="Scripts de Venda" {...props} />
            <div className="w-100">
                <Row>
                    <Col>
                        <Card>
                            <CardHeader
                                style={{
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 1,
                                }}>
                                <Filters
                                    title={<h1>Scripts de Venda</h1>}
                                    data={scripts}
                                    presets={() => (
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={e => onNewClicked(e)}
                                            size="sm">
                                            <span className="btn-inner--icon">
                                                <i className="ni ni-fat-add" />
                                            </span>
                                            Novo Script
                                        </Button>
                                    )}
                                    load={(filters) => {
                                        setLastSearch(filters)
                                        loadScripts(
                                            1,
                                            10,
                                            "titulo",
                                            "asc",
                                            filters)
                                    }}
                                />
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col>
                                        <Table
                                            scripts={scripts || []}
                                            notify={notify}
                                            onTableChange={handleTableChange}
                                            onToggleStatus={handleToggleStatus}
                                            history={props.history}
                                            pageProperties={pageProperties}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
}
